import React from 'react';
import {Paper} from '../Paper/Paper';
import type {PaperProps} from '../Paper/Paper';
import {styled} from '@mui/material/styles';
import {getElevation} from '../helpers/getElevation';

export interface CardProps extends PaperProps {
    raised?: boolean;
}

const StyledCard = styled(Paper)<CardProps>({
    overflow: 'hidden'
});

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({
        children, raised = false, variant, ...props
    }, ref) => (
        <StyledCard
            elevation={getElevation(raised, variant)}
            ref={ref}
            variant={variant}
            {...props}
        >
            {children}
        </StyledCard>
    )
);

Card.displayName = 'Card';
